/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import LOGO from '../../../assets/images/mef-logo.png';
import Underlint from '../../../assets/images/underline.png';
import { gql, useLazyQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import getPositionLabel from '../../../utils/getPositionLabel';
import { mappingKhmerNumberDecimal } from '../../../utils/market-development';
import './style.css';
import useMoment from '../../../hooks/useMoment';

const QUERY_DETAIL = gql`
	query get($id: String!) {
		getLeaveById(id: $id) {
			id
			purpose
			no
			amount
			createdAt
			type
			from
			to
			comeback
			approveByOffice
			approveByOfficeBy
			approveByOfficeAt
			approveByDepartment
			approveByDepartmentBy
			approveByDepartmentAt
			approveByDirectorGeneral
			approveByDirectorGeneralBy
			approveByDirectorGeneralAt
			attachmentFile
			attachmentFileSize
			rejectReason
			user {
				id
				username
				fullName
				fullNameKhmer
				department
			}
			userOffice {
				username
				fullName
				fullNameKhmer
			}
			userDepartment {
				username
				fullName
				fullNameKhmer
			}
			userDG {
				username
				fullName
				fullNameKhmer
			}
			notification {
				id
				read
			}
			reviewingBy
			annualLeaveLeft
			shortLeaveLeft
			totalAnnualLeave
			totalShortLeave
			officeHeadSign
			officeDeputyHeadSign
			departmentHeadSign
			departmentDeputyHeadSign
			dgSign
		}
	}
`;

const Q_GET_EMPLOYEE_BY_ID = gql`
	query get($userId: String!) {
		getEmployeeByUserId(userId: $userId) {
			id
			createdAt
			govtNumber
			mefNumber
			fullName
			fullNameLatin
			gender
			dob
			email
			phoneNumber
			idCardNumber
			firstWorkingPlace
			currentWorkingStatus
		}
	}
`;

const QUERY_SIGNATURE = gql`
	query get($id: String!) {
		getSignatureByUserId(id: $id) {
			id
			signatureImage
		}
	}
`;

function PrintFormat({ userId = null }) {
	moment.locale('km');
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') ? urlParams.get('id') : null;
	const [loadDetail, { data }] = useLazyQuery(QUERY_DETAIL);
	const [getEmployeeInformation, { data: dataEmployeeInformation }] = useLazyQuery(Q_GET_EMPLOYEE_BY_ID);
	const [loadSignature, { data: dataSignature }] = useLazyQuery(QUERY_SIGNATURE);
	const { paperSolarDateString, paperSolarDateStringNoCapital } = useMoment();

	useEffect(() => {
		if (data?.getLeaveById?.user?.id) {
			loadSignature({
				variables: {
					id: data?.getLeaveById?.user?.id,
				},
			});
		}
	}, [data]);

	useEffect(() => {
		if (id) {
			loadDetail({
				variables: {
					id,
				},
			});
		}
	}, [id]);

	useEffect(() => {
		if (userId) {
			getEmployeeInformation({ variables: { userId } });
		}
	}, [userId]);

	return (
		<>
			<center>
				<Box pt="1.5cm" pb="1.5cm" pl="1.2cm" pr="1.2cm" maxW="960px" minH="1350px" bg="white" overflow="hidden">
					<Flex>
						<Flex minW="210px" w="210px" align="center" direction="column">
							<Image mt="4px" src={LOGO} w="114px" h="114px" />
							<Text mt={2} lineHeight="2" textAlign="start" fontSize="14px" fontFamily="KhmerOSMuolLight">
								ក្រសួងសេដ្ឋកិច្ចនិងហិរញ្ញវត្ថុ
								<br />
								និយ័តករធានារ៉ាប់រងកម្ពុជា
							</Text>
						</Flex>
						<Flex flexGrow="1" alignItems="center" direction="column">
							<Text fontSize="16px" fontFamily="KhmerOSMuolLight">
								ព្រះរាជាណាចក្រកម្ពុជា
							</Text>
							<Text mt="4px" fontFamily="KhmerOSSiemReap" fontWeight="bold" fontSize="16px">
								ជាតិ សាសនា ព្រះមហាក្សត្រ
							</Text>
							<Image src={Underlint} h="auto" w="90px" />
						</Flex>
						<Flex w="190px" minW="190px"></Flex>
					</Flex>
					<Box w="100%">
						<center>
							<Text align="center" fontFamily="KhmerOSMuolLight" fontSize="16px">
								សំណើសុំច្បាប់ និងការអនុញ្ញាតច្បាប់
							</Text>
						</center>
					</Box>
					<Flex>
						<Text mt={4} fontSize="18px" align="start">
							<Flex>
								<b fontFamily="KhmerOSMuolLight">យេាង៖ &nbsp;</b>
								<Text ml={4}>
									អនុក្រឹតលេខ ២១៧ អនក្រ.បក ចុះថ្ងៃទី២ ខែឧសភា ឆ្នាំ២០១៣
									ស្ដីពីរបបពីការសុំច្បាប់និងការអនុញ្ញាតច្បាប់គ្រប់ប្រភេទរបស់មន្រ្តីរាជការសុីវិលនៃព្រះរាជាណាចក្រកម្ពុជា។
								</Text>
							</Flex>
						</Text>
					</Flex>
					<Flex mt={2}>
						<Text fontSize="18px" align="center" ml={2}>
							១. គេាត្តនាមនិងនាម
							<Box display="inline-block" borderBottom="0.5px dotted black" minW="257px" mx={2} textAlign="center">
								{data?.getLeaveById?.user?.fullNameKhmer || ''}
							</Box>
							ភេទ
							<Box display="inline-block" borderBottom="0.5px dotted black" minW="148px" mx={2} mb={1} textAlign="center">
								{dataEmployeeInformation?.getEmployeeByUserId?.gender === 'male' ? 'ប្រុស' : 'ស្រី' || ''}
							</Box>
							អត្តលេខ
							<Box display="inline-block" borderBottom="0.5px dotted black" minW="187px" mx={2} textAlign="center">
								{mappingKhmerNumberDecimal(dataEmployeeInformation?.getEmployeeByUserId?.govtNumber || '')}
							</Box>
							<Text ml={5} display="inline">
								មុខតំណែង
								<Box display="inline-block" borderBottom="0.5px dotted black" minW="220px" mx={2} textAlign="center">
									{dataEmployeeInformation?.getEmployeeByUserId?.fullNameLatin === 'Hor Sovathana'
										? 'អគ្គនាយករង'
										: dataEmployeeInformation?.getEmployeeByUserId?.currentWorkingStatus?.currentWorkingStatusPosition
										? getPositionLabel(dataEmployeeInformation?.getEmployeeByUserId?.currentWorkingStatus?.currentWorkingStatusPosition)
										: null}
								</Box>
								អង្គភាព
								<Box display="inline-block" borderBottom="0.5px dotted black" minW="230px" mx={2} textAlign="center">
									{dataEmployeeInformation?.getEmployeeByUserId?.currentWorkingStatus?.currentWorkingStatusOrganization ||
										'និយ័តករធានារ៉ាប់រងកម្ពុជា'}
								</Box>
								លេខទូរស័ព្ទ
								<Box display="inline-block" borderBottom="0.5px dotted black" minW="130px" mx={2} textAlign="center">
									{mappingKhmerNumberDecimal(dataEmployeeInformation?.getEmployeeByUserId?.phoneNumber || '')}
								</Box>
							</Text>
						</Text>
					</Flex>
					<Text align="left" mt={1} ml={2} fontSize="18px">
						២. ប្រភេទនៃច្បាប់ឈប់សម្រាកដែលត្រូវស្នេីរសុំ៖
					</Text>
					<Flex mt={2} ml={2} direction="column" w="100%">
						<Flex align="center" w="98%" justify="space-between">
							<Flex align="center">
								<Box className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.type === 'ANNUAL_LEAVE' && '✔'}
								</Box>
								<Text ml={2} fontSize="18px">
									ឈប់ប្រចាំឆ្នាំ
								</Text>
							</Flex>
							<Flex align="center">
								<Box className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.type === 'SHORT_LEAVE' && '✔'}
								</Box>
								<Text ml={2} fontSize="18px">
									ឈប់រយៈពេលខ្លី
								</Text>
							</Flex>
							<Flex align="center">
								<Box className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.type === 'MATERNITY_LEAVE' && '✔'}
								</Box>
								<Text ml={2} fontSize="18px">
									ឈប់សម្រាកលំហែមាតុភាព
								</Text>
							</Flex>
						</Flex>
						<Flex align="center" mt={2} w="100%" justify="space-between">
							<Flex align="center">
								<Box className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.type === 'SICK_LEAVE' && '✔'}
								</Box>
								<Text ml={2} fontSize="18px">
									ឈប់សម្រាកព្យាបាលជំម្ងឺ
								</Text>
							</Flex>
							<Flex align="center" mr="276px">
								<Box className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.type === 'PERSONAL_LEAVE' && '✔'}
								</Box>
								<Text ml={2} fontSize="18px">
									ឈប់សម្រាកដោយមានកិច្ចការផ្ទាល់ខ្លួន
								</Text>
							</Flex>
						</Flex>
					</Flex>
					<Flex mt={2} ml={2} direction="column">
						{/* Top Row: amount */}
						<Flex justify="space-between" mb={2} mt={2}>
							<Text align="left" fontSize="18px">
								៣. ចំនួនស្នើសុំឈប់&nbsp;&nbsp;
								<Box display="inline-block" borderBottom="0.5px dotted black" minW="30px" align="center" position="relative">
									<b>{data?.getLeaveById?.amount === 0.5 ? '០.៥' : mappingKhmerNumberDecimal(data?.getLeaveById?.amount || 0)}</b>
									&nbsp;&nbsp;ថ្ងៃ
								</Box>
							</Text>
							<Box flex="1" minW="300px" mb={2}>
								<Text fontSize="16px">
									- ថ្ងៃខែឆ្នាំចាប់ផ្តើមឈប់
									<Box display="inline-block" borderBottom="0.5px dotted black" minW="250px" mx={2} position="relative">
										{moment(data?.getLeaveById?.from).format('dddd, DD MMMM YYYY')}
									</Box>
									ដល់
									<Box display="inline-block" borderBottom="0.5px dotted black" minW="180px" mx={2} position="relative">
										{moment(data?.getLeaveById?.to).format('dddd, DD MMMM YYYY')}
									</Box>
								</Text>
								<Text fontSize="16px" mt={2}>
									- ថ្ងៃខែឆ្នាំចូលបម្រើការងារវិញ
									<Box display="inline-block" borderBottom="0.5px dotted black" minW="340px" mx={2} position="relative">
										{moment(data?.getLeaveById?.comeback).format('dddd, DD MMMM YYYY')}
									</Box>
								</Text>
							</Box>
						</Flex>
					</Flex>
					<Flex>
						<Text align="left" ml={2} mt={3} fontSize="18px">
							៤. គេាលបំណង
							<Box display="inline-block" borderBottom="0.5px dotted black" minW="739px" mx={2} position="relative">
								{data?.getLeaveById?.purpose}
							</Box>
						</Text>
					</Flex>
					<Flex mt={6} w="100%" justify="space-between">
						<Flex direction="column">
							<Flex mb={2} mr={4}>
								<Box ml={12} className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.approveByDirectorGeneral === true ? '✔' : null}
								</Box>
								<Text ml={2} fontSize="18px">
									អនុញ្ញាត
								</Text>
								<Box ml={5} className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.approveByDirectorGeneral === false && '✔'}
								</Box>
								<Text ml={2} fontSize="18px">
									មិនអនុញ្ញាត
								</Text>
							</Flex>
							<Text fontSize="18px">{paperSolarDateString(data?.getLeaveById?.approveByDirectorGeneralAt)}</Text>
							<Text mt={2} fontSize="18px" fontFamily="KhmerOSSiemReap" fontWeight="bold">
								ប្រធានអង្គភាពសាមី
							</Text>

							{/* DG Signature  */}
							{data?.getLeaveById?.dgSign?.signatureImage?.file && (
								<Box>
									<Image src={data?.getLeaveById?.dgSign?.signatureImage?.file} alt="DG Signature" w="180px" />
									<Text mt={2} fontFamily="KhmerOSMuolLight" fontSize="16px">
										{data?.getLeaveById?.userDG?.fullNameKhmer}
									</Text>
								</Box>
							)}
						</Flex>
						<Flex direction="column" align="center">
							<Flex mb={2}>
								<Box className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.approveByDepartment === true && data?.getLeaveById?.approveByDepartmentBy ? '✔' : ''}
								</Box>
								<Text ml={2} fontSize="18px">
									អនុញ្ញាត
								</Text>
								<Box ml={4} className="square-box" display="flex" alignItems="center" justifyContent="center">
									{data?.getLeaveById?.approveByOffice === false || (data?.getLeaveById?.approveByDepartment === false && '✔')}
								</Box>
								<Text ml={2} fontSize="18px">
									មិនអនុញ្ញាត
								</Text>
							</Flex>
							<Text fontSize="18px" ml={2}>
								{data?.getLeaveById?.departmentHeadSign?.signatureImage?.file &&
									paperSolarDateStringNoCapital(data?.getLeaveById?.approveByOfficeAt || data?.getLeaveById?.approveByDepartmentAt)}
							</Text>
							<Text mt={2} ml={2} fontSize="18px" fontFamily="KhmerOSSiemReap" fontWeight="bold">
								ប្រធានគ្រប់គ្រងផ្ទាល់
							</Text>
							{data?.getLeaveById?.departmentHeadSign?.signatureImage?.file && (
								<Image src={data?.getLeaveById?.departmentHeadSign?.signatureImage?.file} alt="Signature" w="180px" mt={2} />
							)}
							<Text mt={2} fontFamily="KhmerOSMuolLight" fontSize="16px">
								{data?.getLeaveById?.userDepartment?.fullNameKhmer}
							</Text>
						</Flex>
						<Flex direction="column" align="center">
							<Text fontSize="18px">{paperSolarDateString(data?.getLeaveById?.createdAt)}</Text>
							<Text mt={2} fontSize="18px" fontFamily="KhmerOSSiemReap" fontWeight="bold">
								ហត្ថលេខាមន្រ្តីស្នើសុំ
							</Text>
							{dataSignature?.getSignatureByUserId?.signatureImage?.file && (
								<Image src={dataSignature?.getSignatureByUserId?.signatureImage?.file} alt="Signature" w="180px" mt={2} />
							)}
							<Text mt={2} fontFamily="KhmerOSMuolLight" fontSize="16px">
								{data?.getLeaveById?.user?.fullNameKhmer}
							</Text>
						</Flex>
					</Flex>
					<Flex ml={2} mt="10px" w="100%">
						<Text fontSize="18px">៥. ការិយាល័យ ឬអង្គភាពគ្រប់គ្រងបុគ្គលិក ដេីម្បីជ្រាបជាព័ត៌មាន និងការផ្ទៀងផ្ទាត់</Text>
					</Flex>
					<Flex ml={2} mt={2} w="100%" justify="center">
						<table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
							<thead>
								<tr style={{ fontFamily: 'KhmerOSSiemReap', fontWeight: 'bolder' }}>
									<th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}></th>
									<th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										ឈប់ប្រចាំឆ្នាំ
										<br />
										១៥ថ្ងៃនៃថ្ងៃធ្វេីការ
									</th>
									<th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										ឈប់រយៈពេលខ្លី
										<br />
										១៥ថ្ងៃនៃថ្ងៃធ្វេីការ
									</th>
									<th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										ឈប់សម្រាក
										<br />
										លំហែមាតុភាព ៣ខែ
									</th>
									<th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										ឈប់សម្រាកព្យាបាល
										<br />
										ជម្ងឺ(១២ខែ/ជីវិតការងារ)
									</th>
									<th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										ឈប់សម្រាកដេាយមាន
										<br />
										កិច្ចការផ្ទាល់ខ្លួន(៣ខែ/ជីវិតការងារ)
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>ចំនួនថ្ងៃ ខែ ឈប់សម្រាក</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										{data?.getLeaveById?.totalAnnualLeave !== null
											? mappingKhmerNumberDecimal(data?.getLeaveById?.totalAnnualLeave || 0)
											: 'x'}
									</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										{data?.getLeaveById?.totalShortLeave !== null
											? mappingKhmerNumberDecimal(data?.getLeaveById?.totalShortLeave || 0)
											: 'x'}
									</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>x</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>x</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>x</td>
								</tr>
								<tr>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>ចំនួនថ្ងៃ ខែ នៅសល់</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										{data?.getLeaveById?.annualLeaveLeft !== null
											? mappingKhmerNumberDecimal(data?.getLeaveById?.annualLeaveLeft || 0)
											: 'x'}
									</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
										{data?.getLeaveById?.annualLeaveLeft !== null
											? mappingKhmerNumberDecimal(data?.getLeaveById?.shortLeaveLeft || 0)
											: 'x'}
									</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>x</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>x</td>
									<td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>x</td>
								</tr>
							</tbody>
						</table>
					</Flex>
					<Flex ml={2} mt="5px">
						<Text fontSize="18px">ហត្ថលេខានិងកាលបរិច្ឆេទរបស់មន្ត្រីទទួលបន្ទុកគ្រប់គ្រងបុគ្គលិក</Text>
					</Flex>
					<Flex ml={2}>
						<Text fontSize="18px">
							.............................................................................................................................................................................................................................................................
						</Text>
					</Flex>
					<Flex ml={2} mt={1}>
						<Text fontSize="18px">៦. ការអនុញ្ញាតរបស់ប្រធានស្ថាប័ន/រដ្ឋលេខាធិការ/អគ្គលេខាធិការ/អគ្គនាយក/អគ្គាធិការ/នាយកវិទ្យាស្ថាន</Text>
					</Flex>
					<Flex align="center" justify="center" w="100%">
						<Flex align="center" w="auto">
							<Box ml={2} className="square-box" display="flex" alignItems="center" justifyContent="center" />
							<Text ml={2} fontSize="18px">
								អនុញ្ញាត
							</Text>
						</Flex>
						<Flex align="center" w="auto">
							<Box ml="50px" className="square-box" display="flex" alignItems="center" justifyContent="center" />
							<Text ml={2} fontSize="18px">
								មិនអនុញ្ញាត
							</Text>
						</Flex>
					</Flex>
					<Flex align="center" justify="center" w="auto">
						<Text ml={2} fontSize="18px">
							ថ្ងៃ.............................................ខែ................ឆ្នាំ................ព.ស..............
						</Text>
					</Flex>
					<Flex align="center" justify="center" w="auto">
						<Text ml={2} fontSize="18px">
							រាជធានីភ្នំពេញ ថ្ងៃទី.............ខែ.........គ.ស.............
						</Text>
					</Flex>
				</Box>
			</center>
		</>
	);
}

export default PrintFormat;
